import { render } from "./FormPurchaseRetur.vue?vue&type=template&id=fe5e6ce8"
import script from "./FormPurchaseRetur.vue?vue&type=script&lang=js"
export * from "./FormPurchaseRetur.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__